var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ProfileAvatar from "../../profileIdentity/ProfileAvatar";
import { getCompletedStays, getDisplayName } from "../../profileIdentity/profileIdentity.util";
import { ElementChipList } from "../../uiElements/base/ElementChipList";
import ProfileHeaderChips, { hasProfileHeaderChips } from "./ProfileHeaderChips";
var iconButtonSx = { width: 36, height: 36, color: 'text.secondary' };
var ProfileHeader = function (_a) {
    var profile = _a.profile, mode = _a.mode, onOpenFull = _a.onOpenFull, onRemove = _a.onRemove;
    var t = useTranslation().t;
    var _b = useState(null), menuAnchor = _b[0], setMenuAnchor = _b[1];
    var name = getDisplayName(profile);
    var completedStays = getCompletedStays(profile);
    var staysText = t('{{count}} stays', { count: completedStays });
    var hasChips = hasProfileHeaderChips(profile);
    var openFull = mode === 'simple' ? onOpenFull : undefined;
    var menuEntries = [
        openFull && {
            label: t('Open full profile'),
            Icon: OpenInFullIcon,
            onClick: openFull
        },
        mode === 'full' && {
            label: t('Open in System settings'),
            Icon: OpenInNewIcon,
            onClick: function () { return window.open("/system/profiles/".concat(profile.id), '_blank'); }
        },
        onRemove && {
            label: t('Remove from reservation'),
            Icon: PersonRemoveOutlinedIcon,
            onClick: onRemove,
            danger: true
        },
    ].filter(Boolean);
    var hasMenu = menuEntries.length > 0;
    return (_jsxs(Box, __assign({ sx: { position: 'relative' } }, { children: [_jsxs(Stack, __assign({ direction: 'row', alignItems: hasChips ? 'flex-start' : 'center', gap: '14px' }, (openFull ? {
                role: 'button',
                tabIndex: 0,
                'aria-label': "".concat(t('Open full profile'), ": ").concat(name),
                onClick: openFull,
                onKeyDown: function (event) {
                    if (event.key !== 'Enter' && event.key !== ' ')
                        return;
                    event.preventDefault();
                    openFull();
                }
            } : {}), { sx: openFull ? {
                    cursor: 'pointer',
                    borderRadius: '8px',
                    '&:hover .profile-header-name': { textDecoration: 'underline' },
                    '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: '4px' }
                } : undefined }, { children: [_jsx(ProfileAvatar, { profile: profile, size: 'large', completedStays: completedStays, completedStaysLabel: staysText }), _jsxs(Stack, __assign({ sx: { flex: 1, minWidth: 0, gap: '8px', pt: hasChips ? '4px' : 0, pr: hasMenu ? '32px' : 0 } }, { children: [_jsx(Typography, __assign({ className: 'profile-header-name', color: 'primary', sx: { fontSize: 24, fontWeight: 600, lineHeight: 1.15 } }, { children: name })), hasChips && (_jsx(ElementChipList, { children: _jsx(ProfileHeaderChips, { profile: profile }) }))] }))] })), hasMenu && (_jsx(IconButton, __assign({ "aria-label": t('More actions'), "aria-haspopup": 'menu', "aria-expanded": !!menuAnchor, onClick: function (event) { return setMenuAnchor(event.currentTarget); }, sx: __assign(__assign(__assign({}, iconButtonSx), { position: 'absolute', right: -6 }), (hasChips ? { top: 0 } : { top: '50%', transform: 'translateY(-50%)' })) }, { children: _jsx(MoreVertIcon, { sx: { fontSize: 20 } }) }))), _jsx(Menu, __assign({ anchorEl: menuAnchor, open: !!menuAnchor, onClose: function () { return setMenuAnchor(null); } }, { children: menuEntries.map(function (entry) { return (_jsxs(MenuItem, __assign({ onClick: function () {
                        setMenuAnchor(null);
                        entry.onClick();
                    }, sx: { color: entry.danger ? 'error.main' : undefined } }, { children: [_jsx(ListItemIcon, __assign({ sx: { color: entry.danger ? 'error.main' : undefined } }, { children: _jsx(entry.Icon, { fontSize: 'small' }) })), _jsx(ListItemText, { children: entry.label })] }), entry.label)); }) }))] })));
};
export default ProfileHeader;
